@if (showFtInInput()) {
  <input
    #input
    modus-input
    class="min-w-10 !p-[6px] whitespace-nowrap overflow-hidden text-ellipsis"
    [formControl]="form.controls.feet"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnter()"
  />
  <span class="mx-1">ft</span>
  <input
    #input
    modus-input
    class="!w-9 !p-[6px]"
    [formControl]="form.controls.inches"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnter()"
  />

  <input
    #input
    modus-input
    class="!w-9 !p-[6px] ml-2"
    [formControl]="form.controls.fraction"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnter()"
  />
  <span class="ml-1">/{{ fraction() }}&nbsp;in</span>
} @else {
  <input
    #input
    modus-input
    [formControl]="form.controls.length"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    (keydown.enter)="onEnter()"
  />
}
